import {
	START_ID_LOGIN,
	ID_LOGIN_SUCCESS,
	ID_LOGIN_FAILED,

	START_ANONYMOUS_LOGIN,
	ANONYMOUS_LOGIN_SUCCESS,
	ANONYMOUS_LOGIN_FAILED,

	START_CHECK_AUTH,
	CHECK_AUTH_SUCCESS,
	CHECK_AUTH_FAILED,

	SET_JWT,
	SAVE_JWT_TO_LOCAL_STORAGE,
	CLEAR_JWT,

	SET_CLIENT_LOGIN_CODE_TO_LOCAL_STORAGE,
	CLEAR_CLIENT_LOGIN_CODE,

	START_UPDATE_ME_LANGUAGE_CODE,
	UPDATE_ME_LANGUAGE_CODE_SUCCESS,
	UPDATE_ME_LANGUAGE_CODE_FAILED,
} from './action-types';

export function idLoginAction(clientId, code, source) {
	return {
		type: START_ID_LOGIN,
		clientId,
		code,
		source,
	};
}

export function idLoginSuccessAction() {
	return {
		type: ID_LOGIN_SUCCESS,
	};
}

export function idLoginFailedAction(error, errorMessage) {
	return {
		type: ID_LOGIN_FAILED,
		error,
		errorMessage,
	};
}

export function anonymousLoginAction(clientLoginCode) {
	return {
		type: START_ANONYMOUS_LOGIN,
		clientLoginCode,
	};
}

export function anonymousLoginSuccessAction() {
	return {
		type: ANONYMOUS_LOGIN_SUCCESS,
	};
}

export function anonymousLoginFailedAction(error, errorMessage) {
	return {
		type: ANONYMOUS_LOGIN_FAILED,
		error,
		errorMessage,
	};
}

export function checkAuthAction() {
	return {
		type: START_CHECK_AUTH,
	};
}

export function checkAuthSuccessAction(me) {
	return {
		type: CHECK_AUTH_SUCCESS,
		me,
	};
}

export function checkAuthFailedAction(error, errorMessage) {
	return {
		type: CHECK_AUTH_FAILED,
		error,
		errorMessage,
	};
}

export function setJWTAction(jwt) {
	return {
		type: SET_JWT,
		jwt,
	};
}

export function saveJWTToLocalAction() {
	return {
		type: SAVE_JWT_TO_LOCAL_STORAGE,
	};
}

export function clearJWTAction() {
	return {
		type: CLEAR_JWT,
	};
}

export function setClientLoginCodeToLocalAction(clientLoginCode) {
	return {
		type: SET_CLIENT_LOGIN_CODE_TO_LOCAL_STORAGE,
		clientLoginCode,
	};
}

export function clearClientLoginCodeAction() {
	return {
		type: CLEAR_CLIENT_LOGIN_CODE,
	};
}

export function updateMeLanguageCodeAction(languageCode) {
	return {
		type: START_UPDATE_ME_LANGUAGE_CODE,
		languageCode,
	};
}

export function updateMeLanguageCodeSuccessAction() {
	return {
		type: UPDATE_ME_LANGUAGE_CODE_SUCCESS,
	};
}

export function updateMeLanguageCodeFailedAction(error, errorMessage) {
	return {
		type: UPDATE_ME_LANGUAGE_CODE_FAILED,
		error,
		errorMessage,
	};
}
